import React from 'react';
import LazyHydrate from 'react-lazy-hydration';
import Fullscreen from 'react-full-screen';
import get from 'lodash/get';
import Bem from 'bemHelper';
import DataProvider from 'api/data-provider';
import Icon, { iconTypes } from 'components/icon';
import Button from 'components/button';
import Row, { Col } from 'components/row';

const classesMap = new Bem('mapProjects');

export default function renderMap(mapRenderer, mapTile) {
  const { i18n } = this;
  const map = mapRenderer(true);
  const { landing = {} } = this.props;
  const {
    handleMarkerId, isFullScreenMode, isFullscreenMap, fullMapLegend, animatedMapLegend
  } = this.state;
  const type = get(this, 'props.params.landing.params.objectGroup');

  let mapTileLC = mapTile;
  if (!mapTile && handleMarkerId && landing) {
    mapTileLC = (
      <DataProvider
        url={landing.provider}
        query={{ ...this.getQuery(), id: handleMarkerId }}
        queryJson
        renderer={this.mapTileRenderer}
      />
    );
  }

  const mapLegend = (
    <div //eslint-disable-line
      {...classesMap('mapLegend', { open: fullMapLegend, active: animatedMapLegend })}
      onClick={this.changeMapLegendView}
      ref={el => this.mapLegend = el}
    >
      <div {...classesMap('mapLegendHeader')}>
        <span {...classesMap('text', 'topic')} children={i18n('mapLegendTopic')} />
      </div>
      <div {...classesMap('mapLegendContent')}>
        <ul {...classesMap('mapLegendList')}>
          <li {...classesMap('mapLegendItem')}>
            <Row>
              <Col {...classesMap('col', 'line')} allAuto allPr={0}><Icon {...classesMap('icon', 'highLevel')} type={iconTypes.bc} /></Col>
              <Col {...classesMap('col', 'info')} allPr={0}><span {...classesMap('text')} children={i18n('mapLegendItemHigh')} /></Col>
            </Row>
          </li>
          <li {...classesMap('mapLegendItem')}>
            <Row>
              <Col {...classesMap('col', 'line')} allAuto allPr={0}><Icon {...classesMap('icon', 'mediumLevel')} type={iconTypes.bc} /></Col>
              <Col {...classesMap('col', 'info')} allPr={0}><span {...classesMap('text')} children={i18n('mapLegendItemMedium')} /></Col>
            </Row>
          </li>
          <li {...classesMap('mapLegendItem')}>
            <Row>
              <Col {...classesMap('col', 'line')} allAuto allPr={0}><Icon {...classesMap('icon', 'lowLevel')} type={iconTypes.bc} /></Col>
              <Col {...classesMap('col', 'info')} allPr={0}><span {...classesMap('text')} children={i18n('mapLegendItemLow')} /></Col>
            </Row>
          </li>
          <li {...classesMap('mapLegendItem')}>
            <Row>
              <Col {...classesMap('col', 'line')} allAuto allPr={0}><Icon {...classesMap('icon', 'NA')} type={iconTypes.bc} /></Col>
              <Col {...classesMap('col', 'info')} allPr={0}><span {...classesMap('text')} children={i18n('mapLegendItemNA')} /></Col>
            </Row>
          </li>
          <li {...classesMap('mapLegendItem')}>
            <Row>
              <Col {...classesMap('col', 'line')} allAuto allPr={0}><Icon {...classesMap('icon', 'readyStatus')} type={iconTypes.bc} /></Col>
              <Col {...classesMap('col', 'info')} allPr={0}><span {...classesMap('text')} children={i18n('mapLegendItemReady')} /></Col>
            </Row>
          </li>
        </ul>
      </div>
      <Icon {...classesMap('icon', 'points')} type={iconTypes.bc} />
    </div>
  );

  return (
    <div {...classesMap('mapBlock', { fullScreenMap: isFullScreenMode })} key="mapSearch">
      <LazyHydrate whenIdle>
        <div {...classesMap('mapBlockContent')}>
          <Fullscreen
            enabled={isFullscreenMap}
            onChange={isFullscreenMaps => this.setState({
              isFullscreenMap: isFullscreenMaps,
              isFullScreenMode: isFullscreenMaps,
            })}
          >
            {map}
            {btnSizeMap.call(this)}
            {type !== 'cottageTowns' && mapLegend}
            {mapTileLC}
          </Fullscreen>
        </div>
      </LazyHydrate>
    </div>
  );
}

export function btnSizeMap() {
  const { i18n } = this;
  const { isFullScreenMode, isFullscreenMap } = this.state;
  const btnProps = !isFullScreenMode && !isFullscreenMap ?
    {
      iconType: iconTypes.fullscreen,
      label: i18n('mapExpand')
    } :
    {
      iconType: iconTypes.screen,
      iconSecondType: iconTypes.clear,
      label: i18n('mapMinimize')
    };

  return (
    <div {...classesMap('mapBlockTop')}>
      <span {...classesMap('imgShape')} />
      <Button
        {...classesMap('btn', 'mapFull')}
        onClick={this.changeSizeMap}
        customRenderer
        // {...btnProps}
      >
        <span {...classesMap('btnContent', null, 'btn__content fullscreen')}>
          <Icon {...classesMap('icon', null, 'fullscreen')} type={btnProps.iconType} />
          <span {...classesMap('text', null, 'btn__text fullscreen')}>{btnProps.label}</span>
          {btnProps.iconSecondType &&
            <Icon {...classesMap('icon', 'second', 'btn__icon_second fullscreen')} type={btnProps.iconSecondType} />
          }
        </span>
      </Button>
    </div>
  );
}
